interface Adaptation {
  chat_id: string;
}

export function livechatTemplatesCancelCreateAdapter(
  attendanceId: string,
): Adaptation {
  return {
    chat_id: attendanceId,
  }
}
